<template>
  <div>
    <v-dialog v-model="dialog" eager persistent scrollable max-width="800">
      <v-form ref="CompanyInstershipFormRef" @submit.prevent>
        <v-card>
          <v-card-title class="d-flex align-center">
            <span>{{ action }} Intern Slots</span>
            <v-spacer></v-spacer>
            <v-btn
              icon="mdi-close"
              variant="text"
              color="white"
              @click="closeD()"
            >
            </v-btn>
          </v-card-title>

          <v-card-text style="max-height: 700px" class="">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="name"
                    disabled
                    label="Institute Name"
                    readonly
                    outlined
                    density="compact"
                    variant="outlined"
                    class="mb-3"
                  />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    disabled
                    v-model="programs"
                    label="Programs"
                    readonly
                    outlined
                    density="compact"
                    variant="outlined"
                    class="mb-3"
                  />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="slots"
                    label="Insternship slots"
                    :rules="[formRules.required]"
                    outlined
                    density="compact"
                    variant="outlined"
                    class="mb-3"
                  />
                </v-col>
                <v-col cols="12" v-if="skillsList.length > 0">
                  <v-row class="mt-2">
                    <v-col cols="12" class="my-1">
                      <div class="text-subtitle-1 font-weight-bold">
                        Prefered Skills
                      </div>
                    </v-col>
                    <v-col cols="4" v-for="i in skillsList" :key="i.id">
                      <div
                        class="pa-1 rounded-lg border border-1 cursor: pointer"
                        @click="toggleSkill(i.title)"
                      >
                        <v-checkbox
                          :label="i.title"
                          :model-value="selectedSkills.includes(i.title)"
                          hide-details
                          @click.prevent
                        ></v-checkbox>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="12">
                  <div class="text-subtitle-1 font-weight-bold">
                    Mode of Training <span style="color: red">*</span>
                  </div>
                  <div class="mt-2 d-flex justify-space-between">
                    <div
                      @click="select_mode_of_training('Face to Face')"
                      class="border border-1 py-4 px-4 rounded-lg text-center"
                      :class="
                        mode_of_training == 'Face to Face' ? 'bg-green' : ''
                      "
                    >
                      <div class="text-subtitle-1 font-weight-bold">
                        Face to Face
                      </div>
                      <div
                        class="text-caption"
                        :class="
                          mode_of_training == 'Face to Face' ? '' : 'text-grey'
                        "
                      >
                        Onsite Training
                      </div>
                    </div>
                    <div
                      style="width: 30%; cursor: pointer"
                      @click="select_mode_of_training('Hybrid')"
                      class="border border-1 py-4 px-4 rounded-lg text-center"
                      :class="mode_of_training == 'Hybrid' ? 'bg-green' : ''"
                    >
                      <div class="text-subtitle-1 font-weight-bold">Hybrid</div>
                      <div
                        class="text-caption"
                        :class="mode_of_training == 'Hybrid' ? '' : 'text-grey'"
                      >
                        Mix on-site & remote
                      </div>
                    </div>
                    <div
                      style="width: 30%; cursor: pointer"
                      @click="select_mode_of_training('Work From Home')"
                      class="border border-1 py-4 px-4 rounded-lg text-center"
                      :class="
                        mode_of_training == 'Work From Home' ? 'bg-green' : ''
                      "
                    >
                      <div class="text-subtitle-1 font-weight-bold">
                        Work From Home
                      </div>
                      <div
                        class="text-caption"
                        :class="
                          mode_of_training == 'Work From Home'
                            ? ''
                            : 'text-grey'
                        "
                      >
                        Full Remote Training
                      </div>
                    </div>
                  </div>
                </v-col>
                <v-col cols="12">
                  <v-checkbox
                    v-model="shouldHaveOwnDevice"
                    label="Intern should have own device"
                    outlined
                    density="compact"
                    variant="outlined"
                  />
                </v-col>
                <v-col cols="12" v-if="shouldHaveOwnDevice">
                  <v-autocomplete
                    density="compact"
                    label="Select Device/s intern should have"
                    v-model="selectedDevices"
                    :color="$vuetify.theme.themes.light.inputColor"
                    variant="outlined"
                    multiple
                    closable-chips
                    chips
                    :items="deviceList"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions class="pa-2 mr-4">
            <v-spacer></v-spacer>
            <v-btn outlined @click="closeD()">
              <v-icon>mdi-close-circle-outline</v-icon>
              Cancel
            </v-btn>
            <v-btn
              :color="$vuetify.theme.themes.light.submitBtnsGreen"
              class="white--text"
              density="comfortable"
              variant="flat"
              :disabled="btnLoading"
              :loading="btnLoading"
              @click="save()"
            >
              <v-icon>mdi-check-circle</v-icon>
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <fade-away-message-component
      displayType="default"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
import eventBus from "@/eventBus";
export default {
  props: {
    data: Object,
    action: String,
  },
  data() {
    return {
      dialog: false,
      showDatePicker: false,
      btnLoading: false,
      name: null,
      slots: null,
      selectedDevices: [],
      skillsList: [],
      mode_of_training: null,
      selectedSkills: [],
      programs: null,
      deviceList: ["Laptop", "Desktop Computer"],
      shouldHaveOwnDevice: null,
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
    };
  },
  watch: {
    data: {
      handler(data) {
        this.dialog = true;
        console.log(data);
        this.name = data.institute_name;
        this.programs = data.programs;
        this.slots = data.slots;
        this.selectedDevices = data.deviceRequirements
          ? data.deviceRequirements
          : [];
        this.shouldHaveOwnDevice = data.intern_should_have_own_device == 1;
        this.selectedSkills = data.prefered_skills ? data.prefered_skills : [];
        this.loadSkillList(data.institute_id);
      },
      deep: true,
    },
  },
  methods: {
    toggleSkill(skill) {
      if (!this.selectedSkills.includes(skill)) {
        this.selectedSkills.push(skill);
      } else {
        const idx = this.selectedSkills.indexOf(skill);
        this.selectedSkills.splice(idx, 1);
      }
    },
    async save() {
      let formValid = await this.$refs.CompanyInstershipFormRef.validate();

      if (formValid.valid) {
        this.btnLoading = true;
        let data = {
          orgID: this.data.orgSlotId,
          slots: this.slots,
          shouldHaveOwnDevice: this.shouldHaveOwnDevice,
          deviceList: this.shouldHaveOwnDevice
            ? JSON.stringify(this.selectedDevices)
            : [],
          prefered_skills: JSON.stringify(this.selectedSkills),
          mode_of_training: this.mode_of_training,
        };

        this.axiosCall("/organization/update_intern_slots", "PATCH", data).then(
          (res) => {
            console.log(res);
            if (res.data.status == 200) {
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "success";
              this.fadeAwayMessage.message = res.data.msg;
              this.fadeAwayMessage.header = "System Message";
              this.btnLoading = false;
              this.closeD();
            } else {
              this.btnLoading = false;
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "error";
              this.fadeAwayMessage.message = res.data.msg;
              this.fadeAwayMessage.header = "System Message";
            }
          },
        );
      }
    },

    closeD() {
      eventBus.emit("closeCompanyInsternSlotDialog", true);
      this.btnLoading = false;
      this.dialog = false;
    },

    getPrograms() {
      this.axiosCall("/program", "GET").then((res) => {
        this.programsList = res.data;
      });
    },

    select_mode_of_training(val) {
      this.mode_of_training = val;
    },

    loadSkillList(id) {
      this.axiosCall(
        "/skill-assessement/getSkillCategoryByInstitute/" + id,
        "GET",
      ).then((res) => {
        if (res.data) {
          console.log("SKILLS LIST", res.data);
          this.skillsList = res.data;
        }
      });
    },
  },
};
</script>

<style scoped>
.tbl {
  width: 100%;
  border-collapse: collapse;
}
</style>
